export const C = {
  clay:"#c17f4a",clayD:"#a3662e",clayL:"#d4956a",
  bark:"#3b2f2f",barkL:"#5c3d2e",barkLL:"#7a5230",
  parch:"#f5efe6",parchD:"#ede4d8",parchDD:"#ddd0be",
  cream:"#fff9f2",sand:"#e2cdb5",
  muted:"#8c6f5a",mutedL:"#c4a882",mutedD:"#6b4f3a",
  sage:"#6b8f71",sageL:"#d4edda",sageD:"#4a7051",
  amber:"#d4870a",amberL:"#fde9cc",
  rose:"#c0524a",roseL:"#fde0de",
  ink:"#1e1410",

  // ── New light-theme tokens (additive — do not remove anything above) ──
  background:        '#faf8f5',
  backgroundHero:    '#f0ece2',
  backgroundCard:    '#ffffff',

  textPrimary:       '#1a1209',
  textSecondary:     'rgba(26,18,9,0.55)',
  textMuted:         'rgba(26,18,9,0.35)',
  textOnDark:        '#f0ece2',
  textOnDarkMuted:   'rgba(240,236,226,0.45)',

  accent:            '#c43020',
  accentAmber:       '#d4940a',

  typeGrant:         '#0f2d52',
  typeExhibition:    '#c43020',
  typeResidency:     '#1e4d32',
  typeOpenCall:      '#d4940a',

  typeGrantText:     '#e8e2d9',
  typeExhibitionText:'#f5ede8',
  typeResidencyText: '#dff0e8',
  typeOpenCallText:  '#1a0e00',

  border:            'rgba(26,18,9,0.08)',
  borderStrong:      'rgba(26,18,9,0.15)',

  success:           '#4caf78',
  warning:           '#e8a445',
  danger:            '#c45c5c',
};
